import { useQuery } from '@tanstack/react-query';

import { fetchAdminNames } from 'app/hooks/useFetchReconciliationsPage';

import DeductionAdjustmentsApiHandler from 'app/services/deductionAdjustmentsApiHandler';

import { isPayCalendarMove } from 'app/utils/table/deductionAdjustments';

import {
  DeductionAdjustmentsPage,
  FetchDeductionAdjustmentsRequest,
} from 'app/types/deductionAdjustments';

export const DEDUCTION_ADJUSTMENTS_QUERY_KEY = 'fetchDeductionAdjustments';

/** Lists deduction adjustments for the people or reports given, newest first, naming the admin who added each. */
const useFetchDeductionAdjustments = (request: FetchDeductionAdjustmentsRequest, enabled = true) =>
  useQuery<DeductionAdjustmentsPage, Error>(
    [
      DEDUCTION_ADJUSTMENTS_QUERY_KEY,
      request.individualIds,
      request.individualReportIds,
      request.page,
      request.size,
    ],
    async () => {
      const adjustments = await DeductionAdjustmentsApiHandler.listAdjustments(request);
      const adminIds = adjustments.list
        .filter((adjustment) => !isPayCalendarMove(adjustment))
        .map((adjustment) => adjustment.createdBy);
      const adminNames = await fetchAdminNames([...new Set(adminIds)]);

      return {
        ...adjustments,
        list: adjustments.list.map((adjustment) => ({
          ...adjustment,
          createdByName: adminNames.get(adjustment.createdBy),
        })),
      };
    },
    {
      enabled: enabled && !!(request.individualIds?.length || request.individualReportIds?.length),
    }
  );

export default useFetchDeductionAdjustments;
